import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

const JobDescription = ({ description }: { description: string }) => {
  const { t } = useTranslation("goHire", { keyPrefix: "createJobPage.previewAndPublishJob" });

  return (
    <Box component="section" sx={styles.container}>
      <Typography sx={styles.title}>{t("jobDescription")}</Typography>
      {/* <Typography sx={styles.subTitle}>{t("responsibleTo", { position: "Head of Sport" })}</Typography> */}
      <Typography sx={styles.description}>{description}</Typography>
    </Box>
  );
};

export default JobDescription;

const styles = {
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  title: {
    fontFamily: "Montserrat",
    color: "var(--Dark---1000, #111)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  subTitle: {
    fontFamily: "Montserrat",
    color: "var(--Dark---800, #414141)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px",
  },
  description: {
    fontFamily: "Montserrat",
    color: "var(--Dark---800, #414141)",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
  },
};
